import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { generateErrorConfig } from './utils';

const ErrorView = ({
  className,
  size = 160,
  config
}) => {
  const error = generateErrorConfig(config);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("img", {
    draggable: false,
    className: styles.img,
    width: size,
    src: error.img
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, error.title), !!error.content && /*#__PURE__*/React.createElement("div", {
    className: styles.wrapContent
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.content
  }, error.content)));
};

export default ErrorView;